import i18n from 'i18next'
import { initReactI18next, useTranslation } from 'react-i18next'
import { id } from './language/id'
import { en } from './language/en'

const initialLang = localStorage.getItem('lang') || 'id'

i18n.use(initReactI18next).init({
  resources: {
    id: {
      translation: {
        ...id,
      },
    },
    en: {
      translation: {
        ...en,
      },
    },
  },
  lng: initialLang, //main language
  fallbackLng: 'id', // standby language
  interpolation: {
    escapeValue: false, //  reaktif rendering
  },
})

function useTranslate() {
  const { t } = useTranslation()
  return { t }
}

export default useTranslate
